<template>
  <curve-page :project-id="THSR_MANUAL_PROJECT_ID" />
</template>

<script>
import CurvePage from '@/views/Curve.vue';
import { THSR_MANUAL_PROJECT_ID } from '@/lib/base/project';

export default {
  name: 'ManualCurve',
  components: { CurvePage },
  data() {
    return { THSR_MANUAL_PROJECT_ID };
  },
};
</script>
